var render = function (_h,_vm) {var _c=_vm._c;return _c('base-button',_vm._g(_vm._b({staticClass:"__social",class:(Array.isArray(_vm.data.class) ? _vm.data.class : [_vm.data.class]).concat( [_vm.data.staticClass],
    [{
      __tw: !!_vm.props.tw,
      __fb: _vm.props.fb,
    }] )},'base-button',_vm.props,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }